<template>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商品详情</span>
      </div>
      <div class="box-content">
          <div class="image"></div>
          <div class="name"><p>{{order.goodsname}}</p><p>{{order.attrs}}</p></div>
           <div class="price">¥<span>{{order.amount}}</span></div>
           <div class="num"><span>x {{order.number}}</span></div>
      </div>
      </el-card>
</template>

<script>
export default {
  props:["order"]
}
</script>

<style scoped>
.box-card{margin-top: 10px;}
.box-content{display: flex;position: relative;}
.image {
  width: 100px;
  height: 100px;
  background: url(https://image.suhuishou.com/attached/image/20181120/20181120171959_48005.jpg)
    center center no-repeat;
  background-size: 100%;
  display: inline-block;
}
.name{width: 960px;margin-left:40px;}
.name p:nth-child(1){font-weight: 700;}
.name p:nth-child(2){margin:20px 0;}
.name p span{color:#888;margin-left:10px;}
.price{font-size: 14px;color:#f9415d}
.price span{font-size: 24px;}
.num{position: absolute;bottom: 0px;right:20px;color:#666}
</style>
